import React, { Component } from 'react'; 
import './App.css';
import QuoteCalc from './steps/Steps';
// import '../node_modules/bootstrap/dist/css/bootstrap.min.css';


class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeStep: 0,
      firstStepState: {},
      secondStepState: {},
      thirdStepState: {},
      utmParams: {}, // Store UTM parameters
    };
    this.onFlightChange = this.onFlightChange.bind(this);
    // this.onTextChange = this.onTextChange.bind(this);
    this.saveTopState = this.saveTopState.bind(this);
    this.readTopState = this.readTopState.bind(this);
    this.captureUTMParams = this.captureUTMParams.bind(this);

  }

  /**
   * Capture UTM parameters and gclid from URL
   * @return {void}
   */
  captureUTMParams() {
    const urlParams = new URLSearchParams(window.location.search);
    const utmParams = {
      utm_source: urlParams.get('utm_source') || '',
      utm_medium: urlParams.get('utm_medium') || '',
      utm_campaign: urlParams.get('utm_campaign') || '',
      utm_term: urlParams.get('utm_term') || '',
      gclid: urlParams.get('gclid') || ''
    };

    // Debug: Log captured UTM parameters
    console.log('[QC UTM DEBUG] Captured UTM parameters:', utmParams);

    // Store in sessionStorage to persist across page navigation
    sessionStorage.setItem('qc_utm_params', JSON.stringify(utmParams));

    this.setState({ utmParams: utmParams });
  }

  componentDidMount() {
    // Capture UTM parameters on component mount
    this.captureUTMParams();

    // Also check sessionStorage in case user navigated from another page
    const storedUTM = sessionStorage.getItem('qc_utm_params');
    if (storedUTM) {
      try {
        const utmParams = JSON.parse(storedUTM);
        this.setState({ utmParams: utmParams });
        console.log('[QC UTM DEBUG] Loaded UTM parameters from sessionStorage:', utmParams);
      } catch (e) {
        console.error('[QC UTM DEBUG] Error parsing stored UTM params:', e);
      }
    }
  }
  saveTopState(newTopState, callback) {
    this.setState(newTopState, callback);
  }
  readTopState(topState) {
    return this.state[topState];
  }

  onFlightChange(event) {
    let flights = this.state.flights;
    flights[event.target.name] = event.target.value;
    this.setState({
      flights : flights 
    });
    console.log(this.state.flights)
  }
  // onTextChange(event) {
  //   this.setState({from: event.target.value});

  // }
  onButtonClick(btn) { 
    console.log(this.state.from);
    alert(btn);

  }
  

  render(){
      return (
        <div>
          <div>
            <QuoteCalc 
              saveTopState={this.saveTopState}
              readTopState={this.readTopState}
            />
          </div>

        </div>
  );
}
}




export default App;



// WEBPACK FOOTER //
// ./src/App.js